/* TSO dynamic lead time — ONE implementation, three consumers:
   - builder ATC (custom-build-product-*-script.js) -> cart line property
   - PDP Proof live card ([data-tso-lead] span, auto-inits below)
   Model: item lead = base range + MAX(selected option delays, text delay) — never a sum;
   build lead = elementwise max across base + selected accessories (ships together). */
window.TSOLead = window.TSOLead || (function () {
  function attrInt(el, name) { return el ? parseInt(el.getAttribute(name), 10) || 0 : 0; }
  function q(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function maxLeadDays(opts) {
    var d = 0;
    opts.forEach(function (o) { d = Math.max(d, parseInt(o.getAttribute('data-leaddays'), 10) || 0); });
    return d;
  }
  function hasText(inputs) {
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value && inputs[i].value.trim() !== '') return true;
    }
    return false;
  }
  function compute() {
    var cbp = document.querySelector('custom-build-product');
    if (!cbp) return null;
    var textLead = attrInt(cbp, 'data-textleaddays');
    var baseMin = attrInt(cbp, 'data-leadmin');
    var baseMax = attrInt(cbp, 'data-leadmax');
    var mainDelay = Math.max(
      maxLeadDays(q('#primaryColorMain option:checked, #secondaryColorMain option:checked')),
      hasText(q('.personalize-wrap-main.active .personalize-input')) ? textLead : 0
    );
    var min = baseMin + mainDelay, max = baseMax + mainDelay;
    q('.custom-product-variant-item.accessories-product.selected').forEach(function (acc) {
      var pp = document.querySelector('.accessories-popup-overlay[data-pid="' + acc.getAttribute('data-pid') + '"]');
      var d = 0;
      if (pp) {
        var textInputs = pp.querySelector('.personalize-wrap-acc')
          ? q('.personalize-wrap-acc.active .personalize-input', pp)
          : q('.personalize-input', pp);
        d = Math.max(
          maxLeadDays(q('.accessories-popup-select.primary-colors option:checked, .accessories-popup-select.secondary-colors option:checked', pp)),
          hasText(textInputs) ? textLead : 0
        );
      }
      min = Math.max(min, attrInt(acc, 'data-leadmin') + d);
      max = Math.max(max, attrInt(acc, 'data-leadmax') + d);
    });
    if (min > max) min = max;
    return { min: min, max: max, isBase: min === baseMin && max === baseMax };
  }
  function format(min, max) {
    if (max <= 0) return null;
    if (min > max) min = max;
    if (max < 10) return (min === max ? String(max) : min + '–' + max) + ' business days';
    var a = Math.ceil(min / 5), b = Math.ceil(max / 5);
    return (a === b ? String(b) : a + '–' + b) + (b === 1 ? ' week' : ' weeks');
  }
  return { compute: compute, format: format };
})();

/* Live surfaces, builder pages only:
   - [data-tso-lead] (pdp-proof [lead_time] token): base/default state keeps the
     data-prefix ("As little as ..."); any delay-carrying selection switches to
     the computed range.
   - [data-tso-lead-summary] (builder summary row): plain computed range,
     unhidden once there's data.
   Non-builder pages: no-op, the server-rendered base range stands. */
(function () {
  if (window.__tsoLeadInit) return;
  window.__tsoLeadInit = true;
  if (!document.querySelector('custom-build-product')) return;
  var card = document.querySelector('[data-tso-lead]');
  var summary = document.querySelector('[data-tso-lead-summary]');
  if (!card && !summary) return;
  var prefix = card ? card.getAttribute('data-prefix') || '' : '';
  var t;
  function update() {
    var r = window.TSOLead.compute();
    if (!r || r.max <= 0) return;
    var label = window.TSOLead.format(r.min, r.max);
    if (card) card.textContent = r.isBase && prefix ? prefix + ' ' + label : label;
    if (summary) {
      var v = summary.querySelector('[data-tso-lead-value]');
      if (v) v.textContent = label;
      summary.hidden = false;
    }
  }
  function schedule() { clearTimeout(t); t = setTimeout(update, 100); }
  new MutationObserver(schedule).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class'] });
  document.addEventListener('change', schedule, true);
  document.addEventListener('input', schedule, true);
  update();
})();
